import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { telechargerFichier } from '../../App_Code/API';
import { indexExeCourant, exerciceCourant, exerciceSuivant } from '../../App_Code/ExeComptable';
import { toEuros, toDate, estEnCoursDeChargement} from '../../App_Code/Utils';
import { mapStateToPropsWrapper, verificationProps } from '../CaptureErreurs';
import * as Actions from '../../Actions/GlobalActions';
import Chargement from '../Chargement';
import Tableau from '../Tableau';

const SelectionAffichage = ({
    estMembreCS, detail, filtre, changerDetail, changerFiltre, chargeDepenses, exeSuivant_Visible, iChoixExe, iLimiteExe, sDateExe
}) => (
    <div className="d-flex justify-content-around mb-3">
        {estMembreCS && (
            <div className="btn-group" role="group" aria-label="Type">
                <button
                    type="button"
                    className={`btn btn-warning p-2 ${detail ? '' : 'active'}`}
                    onClick={() => changerDetail(false)} 
                >                    
                    <span className="badge badge-pill badge-cs" title="Vous avez accès à ce filtre car vous êtes membre du conseil syndical">
                        CS
                    </span>{' '}
                    Dépenses
                </button>
                <button
                    type="button"
                    className={`btn btn-warning p-2 ${detail ? 'active' : ''}`}
                    onClick={() => changerDetail(true)}
                >
                   <span className="badge badge-pill badge-cs" title="Vous avez accès à ce filtre car vous êtes membre du conseil syndical">
                        CS
                    </span>{' '}
                    Dépenses détaillées
                </button>
            </div>
        )}
        <div className="btn-group" role="group" hidden={!detail || !exeSuivant_Visible}>
            <button type="button" className="btn btn-outline-secondary p-2" disabled={iChoixExe === 0} onClick={() => chargeDepenses(iChoixExe-1)}>
                <i className="fas fa-arrow-left" title="Exercice précédent"/>
            </button>
            <button className="btn btn-outline-secondary active">{sDateExe}</button>
            <button type="button" className="btn btn-outline-secondary p-2" disabled={iChoixExe === iLimiteExe} onClick={() => chargeDepenses(iChoixExe+1)}>
                <i className="fas fa-arrow-right" title="Exercice suivant"/>
            </button>
        </div>

        <div className="btn-group" role="group" aria-label="Filtre">
            <button
                type="button"
                className={`btn btn-primary p-2 ${filtre === 'CptBP' ? 'active' : ''}`}
                onClick={() => changerFiltre('CptBP')}
            >
                Opérations courantes
            </button>
            <button
                type="button"
                className={`btn btn-primary p-2 ${filtre === 'CptHBP' ? 'active' : ''}`}
                onClick={() => changerFiltre('CptHBP')}
            >
                Travaux et opérations exceptionnelles
            </button>
        </div>
    </div>
);

const LigneBudget = ({ BudgetDepNonNul, Budget, Depense }) => {
    if (!BudgetDepNonNul) return toEuros(Depense, true);

    return (Depense > Budget) ? (
        <div
            className="text-danger"
            title="Le montant des dépenses dépasse le budget prévisionel"
            data-toggle="tooltip"
            data-placement="top"
        >
            {toEuros(Depense, true)}
        </div>
    ) : (toEuros(Depense, true));
};

/* AFFICHE SIMPLE */

function EnteteSimple(opCourantes, lsExercices) {

    const exCourant = exerciceCourant(lsExercices);
    const exSuivant = exerciceSuivant(lsExercices);

    const dateDebCour = new Date(exCourant.DateDeb);
    const dateFinCour = new Date(exCourant.DateFin);

    const dateDebFutur = new Date(exSuivant.DateDeb);
    const dateFinFutur = new Date(exSuivant.DateFin);

    const exeCourant = dateDebCour.getFullYear() === dateFinCour.getFullYear() ? toDate(exCourant.DateDeb, 'YYYY') : `${toDate(exCourant.DateDeb, 'YY')}/${toDate(exCourant.DateFin, 'YY')}`;
    const exeFutur = dateDebFutur.getFullYear() === dateFinFutur.getFullYear() ? toDate(exSuivant.DateDeb, 'YYYY') : `${toDate(exSuivant.DateDeb, 'YY')}/${toDate(exSuivant.DateFin, 'YY')}`;



    return (
        <tr>
            <th scope="col">Charge</th>
            <td>Intitulé</td>
            <td>Fournisseur</td>
            <th scope="col" className="text-right">
                Budget {opCourantes && exeCourant}
            </th>
            <th scope="col" className="text-right">
                Dépenses {opCourantes && exeCourant}
            </th>
            <th scope="col" className="text-right">
                {/* Dépenses {opCourantes && exeFutur} */}
                Dépenses ultérieures
            </th>
        </tr>
    );
}

const LigneSimple = ({
    Num, Code, Libelle, IndFou, LibFou, BudgetDepNonNul, Budget, Depense, DepensePlus,
}) => (
    <tr>
        <td colSpan="1" />
        <td>{Num}-{Code} {Libelle}</td>
        <td>{IndFou} {LibFou && <span>({LibFou})</span>}</td>
        <td className="text-right text-nowrap">{BudgetDepNonNul && toEuros(Budget, true)}</td>
        <td className="text-right text-nowrap"><LigneBudget BudgetDepNonNul={BudgetDepNonNul} Budget={Budget} Depense={Depense} /></td>
        <td className="text-right text-nowrap">{DepensePlus !== 0 && toEuros(DepensePlus)}</td>
    </tr>
);

function LignesSimple(charges, filtre) {
    const TotalCharges = {
        BudgetNonNul: false,
        Budget: 0,
        Depense: 0,
        DepensePlus: 0,
    };

    const LignesCharges = charges.map((charge, i) => {
        const TotalComptes = {
            BudgetNonNul: false,
            Budget: 0,
            Depense: 0,
            DepensePlus: 0,
        };

        const fLsComptes = charge.LsComptes.filter(compte => compte.Type === filtre);
        if (fLsComptes.length === 0) return null;

        const LignesComptes = fLsComptes.map((compte, j) => {
            TotalComptes.BudgetNonNul = TotalComptes.BudgetNonNul || compte.BudgetDepNonNul;
            TotalComptes.Budget += compte.Budget;
            TotalComptes.Depense += compte.Depense;
            TotalComptes.DepensePlus += compte.DepensePlus;

            return (compte.Budget === 0 && compte.Depense === 0 && compte.DepensePlus === 0) ? null : <LigneSimple key={j} {...compte} />;
            // return <LigneSimple key={j} {...compte} />;
        });

        if (TotalComptes.Budget === 0 && TotalComptes.Depense === 0 && TotalComptes.DepensePlus === 0) return null;

        TotalCharges.BudgetNonNul = TotalCharges.BudgetNonNul || TotalComptes.BudgetNonNul;
        TotalCharges.Budget += TotalComptes.Budget;
        TotalCharges.Depense += TotalComptes.Depense;
        TotalCharges.DepensePlus += TotalComptes.DepensePlus;

        return (
            <React.Fragment key={i}>
                <tr className="table-primary">
                    <th colSpan="2">
                        {charge.Code} - {charge.Libelle}
                    </th>
                    <td />
                    <th className="text-right text-nowrap">{TotalComptes.BudgetNonNul && toEuros(TotalComptes.Budget, true)}</th>
                    <th className="text-right text-nowrap"><LigneBudget BudgetDepNonNul={TotalComptes.BudgetNonNul} Budget={TotalComptes.Budget} Depense={TotalComptes.Depense} /></th>
                    <th className="text-right text-nowrap">{toEuros(TotalComptes.DepensePlus, true)}</th>
                </tr>
                {LignesComptes}
            </React.Fragment>
        );
    });

    return (
        <React.Fragment>
            {LignesCharges}
            <LigneTotalSimple colSpanPrec="0" colSpanTotaux="3" titreTotaux="TOTAL GLOBAL" totaux={TotalCharges} />
        </React.Fragment>
    );
}

const LigneTotalSimple = ({
    colSpanPrec, colSpanTotaux, titreTotaux, totaux,
}) => (
    <tr className="table-active" style={{fontSize: 20}}>
        {colSpanPrec !== '0' && <th colSpan={colSpanPrec} />}
        <th colSpan={colSpanTotaux}>
            {titreTotaux}
        </th>
        <th className="text-right text-nowrap">{totaux.BudgetNonNul && toEuros(totaux.Budget, true)}</th>
        <th className="text-right text-nowrap"><LigneBudget BudgetDepNonNul={totaux.BudgetNonNul} Budget={totaux.Budget} Depense={totaux.Depense} /></th>
        <th className="text-right text-nowrap">{toEuros(totaux.DepensePlus, true)}</th>
    </tr>
);

/* AFFICHE DETAILS */

const EnteteDetails = (
    <tr>
        <th scope="col">Charge</th>
        <th scope="col">Compte</th>
        <td>Libellé</td>
        <th scope="col" className="text-right">Budget</th>
        <td>Fournisseur</td>
        <td>Date</td>
        <th scope="col" className="text-right">
            Factures
        </th>
        <th scope="col" className="text-right">
            Charges Loc
        </th>
        <th scope="col" className="text-right">
            TVA
        </th>
        <th scope="col" className="text-right">
            Doc
        </th>
    </tr>
);

const LigneDetails = ({
    LibFac, LibContrePartie, DateEcr, TTC, ChargesLoc, Tva, DocToken,
}) => (
    <tr>
        <td colSpan="2" />
        <td colSpan="2">{LibFac}</td>
        <td>{LibContrePartie}</td>
        <td>{toDate(DateEcr, 'L')}</td>
        <td className="text-right text-nowrap">{toEuros(TTC, true)}</td>
        <td className="text-right  text-nowrap">{toEuros(ChargesLoc)}</td>
        <td className="text-right  text-nowrap">{toEuros(Tva)}</td>
        <td className="text-right">
            {DocToken && (
                <a target="_blank" href={telechargerFichier(DocToken)}>
                    <i className="fa fas fa-download mr-1" title="Télécharger le document" />
                </a>
            )}
        </td>
    </tr>
);

function LignesDetails(charges, filtre) {
    const TotalCharges = {
        BudgetNonNul: false,
        Budget: 0,
        Fact: 0,
        Charges: 0,
        Tva: 0,
    };

    const LignesCharges = charges.map((charge, i) => {
        const TotalComptes = {
            BudgetNonNul: false,
            Budget: 0,
            Fact: 0,
            Charges: 0,
            Tva: 0,
        };

        const fLsComptes = charge.LsComptes.filter(compte => compte.Type === filtre);
        if (fLsComptes.length === 0) return null;

        const LignesComptes = fLsComptes.map((compte, j) => {
            const TotalDetails = {
                BudgetNonNul: compte.BudgetDepNonNul,
                Budget: compte.Budget,
                Fact: 0,
                Charges: 0,
                Tva: 0,
            };

            if (compte.LsDetail.length === 0 && !compte.BudgetDepNonNul) return null;

            const LignesDetail = compte.LsDetail.map((details, k) => {
                TotalDetails.Fact += details.TTC;
                TotalDetails.Charges += details.ChargesLoc;
                TotalDetails.Tva += details.Tva;

                return <LigneDetails key={k} {...details} />;
            });

            TotalComptes.BudgetNonNul = TotalComptes.BudgetNonNul || TotalDetails.BudgetNonNul;
            TotalComptes.Budget += TotalDetails.Budget;
            TotalComptes.Fact += TotalDetails.Fact;
            TotalComptes.Charges += TotalDetails.Charges;
            TotalComptes.Tva += TotalDetails.Tva;

            return (
                <React.Fragment key={j}>
                    <tr className="table-secondary">
                        <th colSpan="1" />
                        <th colSpan="2" >
                            {compte.Num}-{compte.Code} - {compte.Libelle}
                        </th>
                        <th className="text-right text-nowrap">{toEuros(TotalDetails.Budget, true)}</th>
                        <td />
                        <td />
                        <th className="text-right text-nowrap"><LigneBudget BudgetDepNonNul={TotalDetails.BudgetNonNul} Budget={TotalDetails.Budget} Depense={TotalDetails.Fact} /></th>
                        <th className="text-right text-nowrap">{toEuros(TotalDetails.Charges, true)}</th>
                        <th className="text-right text-nowrap">{toEuros(TotalDetails.Tva, true)}</th>
                        <th />
                    </tr>
                    {LignesDetail}
                </React.Fragment>
            );
        });

        if (TotalComptes.Budget === 0 && TotalComptes.Fact === 0 && TotalComptes.Charges === 0 && TotalComptes.Tva === 0) return null;

        TotalCharges.BudgetNonNul = TotalCharges.BudgetNonNul || TotalComptes.BudgetNonNul;
        TotalCharges.Budget += TotalComptes.Budget;
        TotalCharges.Fact += TotalComptes.Fact;
        TotalCharges.Charges += TotalComptes.Charges;
        TotalCharges.Tva += TotalComptes.Tva;

        return (
            <React.Fragment key={i}>
                <tr className="table-primary">
                    <th colSpan="3" >
                        {charge.Code} - {charge.Libelle}
                    </th>
                    <th className="text-right text-nowrap">{toEuros(TotalComptes.Budget, true)}</th>
                    <td />
                    <td />
                    <th className="text-right text-nowrap"><LigneBudget BudgetDepNonNul={TotalComptes.BudgetNonNul} Budget={TotalComptes.Budget} Depense={TotalComptes.Fact} /></th>
                    <th className="text-right text-nowrap">{toEuros(TotalComptes.Charges, true)}</th>
                    <th className="text-right text-nowrap">{toEuros(TotalComptes.Tva, true)}</th>
                    <th />
                </tr>
                {LignesComptes}
            </React.Fragment>
        );
    });

    return (
        <React.Fragment>
            {LignesCharges}
            <LigneTotalDetails colSpanPrec="0" colSpanTotaux="3" titreTotaux="TOTAL GLOBAL" totaux={TotalCharges} />
        </React.Fragment>
    );
}

const LigneTotalDetails = ({
    colSpanPrec, colSpanTotaux, titreTotaux, totaux,
}) => (
    <tr className="table-active" style={{fontSize: 20}}>
        {colSpanPrec !== '0' && <th colSpan={colSpanPrec} />}
        <th colSpan={colSpanTotaux}>
            {titreTotaux}
        </th>
        <th className="text-right text-nowrap">{toEuros(totaux.Budget, true)}</th>
        <th />
        <th />
        <th className="text-right text-nowrap"><LigneBudget BudgetDepNonNul={totaux.BudgetNonNul} Budget={totaux.Budget} Depense={totaux.Fact} /></th>
        <th className="text-right text-nowrap">{toEuros(totaux.Charges, true)}</th>
        <th className="text-right text-nowrap">{toEuros(totaux.Tva, true)}</th>
        <th />
    </tr>
);

class PageDepenses extends Component {
    state = {
        detail: false,
        filtre: 'CptBP',
        sDateExe: null,
        iChoixExe : indexExeCourant(this.props.LsExercices),
        lsExe : this.props.LsExercices
    };

    getDateExercice = (index) => {
        let dateDebExe = this.state.lsExe[index].DateDeb
        let dateTemp = new Date(dateDebExe)
        const debutJanvier = dateTemp.getMonth() === 0;
        const dateFin = dateTemp.setFullYear(dateTemp.getFullYear() + 1);

        return debutJanvier ? toDate(dateDebExe, 'YYYY') : `${toDate(dateDebExe, 'YYYY')} - ${toDate(dateFin, 'YYYY')}`;
    }

    chargeDepensesExe = (index) => {
        let numExe = this.state.lsExe[index].Num
        //si exe selectioné déjà chargé alors on le recharge pas 
        if(this.props.NumExe === numExe) return

        this.props.actions.obtenirChargesExe(numExe)
        this.setState({iChoixExe : index, sDateExe : this.getDateExercice(index)})
    }

    changerDetail = (valeur) => {
        this.setState({ detail: valeur });
        //si on retourne en dépenses non détaillé & si on est pas déjà en exercice courant, on le recharge
        if(valeur === false && this.state.iChoixExe !== 0) {
            let idExeCourant = indexExeCourant(this.props.LsExercices)
            this.props.actions.obtenirChargesExe(this.state.lsExe[idExeCourant].Num)
            this.setState({iChoixExe : idExeCourant, sDateExe : this.getDateExercice(idExeCourant)})
        }
    };

    changerFiltre = (valeur) => {
        this.setState({ filtre: valeur });
    };

    componentDidMount(){
        if(this.props.Charges === "EN_COURS_DE_CHARGEMENT") this.props.actions.obtenirChargesExeCourant()
        this.setState({sDateExe : this.getDateExercice(indexExeCourant(this.props.LsExercices))})
    }

    render() {
        const {
            EstMembreCS, Charges, NumExe, ExeSuivant_Visible, LsExercices
        } = this.props;
        const { detail, filtre, iChoixExe, lsExe, sDateExe } = this.state;
        if (estEnCoursDeChargement(Charges)) return <Chargement />;

        const opCourantes = filtre === 'CptBP';

        return (
            <React.Fragment>
                <SelectionAffichage
                    estMembreCS={EstMembreCS}
                    detail={detail}
                    filtre={filtre}
                    changerDetail={this.changerDetail}
                    changerFiltre={this.changerFiltre}
                    chargeDepenses={this.chargeDepensesExe}
                    exeSuivant_Visible={ExeSuivant_Visible}
                    iChoixExe={iChoixExe}
                    iLimiteExe={lsExe.length - 1}
                    sDateExe={sDateExe}
                />
                <div className="table-responsive">
                    {detail ?
                        <Tableau Entete={EnteteDetails} Lignes={LignesDetails(Charges.LsCharges, filtre)} PetitesLignes /> :
                        <Tableau Entete={EnteteSimple(opCourantes, LsExercices)} Lignes={LignesSimple(Charges.LsCharges, filtre)} PetitesLignes />
                    }
                </div>
            </React.Fragment>
        );
    }
}
PageDepenses.displayName = 'PageDepenses';
PageDepenses.requiredProps = [
    'Charges', // Liste des charges
    'LsExercices', //Liste des exercices de la copro
    'NumExe', //Numero de l'exercice actuellement chargé
];

function mapStateToProps({
    AdhStore: { EstMembreCS },
    CopStore: {
        Cop: { LsExercices },
        Charges,
        NumExe,
    },
    SynStore: {
        Syn : { ExeSuivant_Visible }
    },
}) {
    return {
        EstMembreCS, Charges, ExeSuivant_Visible, NumExe, LsExercices
    };
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(Actions, dispatch) };
}

export default connect(mapStateToPropsWrapper(mapStateToProps), mapDispatchToProps)(verificationProps(PageDepenses));



// WEBPACK FOOTER //
// ./src/components/MaCopro/PageDepenses.js